// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sGM1Q","left":"styles_left__2XsmG"};